import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import {useOnClickOutside} from '../../../hooks/useOnClickOutside';
import TextField from '../../../styled-base/input/text';
import {uniqueArrayObject} from '../../../utils/function';
import { imgUrl } from '../../../utils/url';

const UTM_STRING = 'utm_source=workboard&utm_medium=referral';
const isUnsplashURL = (url: string): boolean => url.indexOf("https://images.unsplash.com/") != -1;

const ImageBox = (props: any) => {
    const image = props.image;
    const imgBaseUrl = imgUrl('/images/icons/board/');
    let bgURL = `${imgBaseUrl}${image}`;
    let themeField = "themeImg";
    if (isUnsplashURL(image)) {
      bgURL = image;
    }
    return (
        <div
            className={`wsBoardThemeImgWrap ${(props.isActive) ? " active" : ""}`}
            onClick={e =>
            props.setTheme(
                e,
                themeField,
                `${bgURL}`
            )
            }
        >
            <div
            className='displayCell wsBoardThemeImgDiv'
            style={{
                backgroundImage: `url(${bgURL})`
            }}
            />
        </div>
    )
}

const ImageRow = (props: any) => {
    const uImage = props.uImage;
    return (
        <div
            className="imageRow"
            onMouseOver={() => props.onHover(uImage.id)}
            onMouseLeave={() => props.onHover(null)}
        >
            <img
                className="unsplashRows"
                alt={uImage.alt_description}
                src={uImage.urls.thumb}
                onClick={e => props.selectImage(e, uImage)}
            />
            <div className="unsplashCredits" style={{display: (props.showTitle ? 'block' : 'none')}}>
                <a href={`${uImage.user.links.html}?${UTM_STRING}`} target="_blank">
                    {uImage.user.first_name}
                </a>
            </div>
        </div>
    )
}

const UnsplashImages = (props: any) => {
    const { t } = useTranslation();
    let defaultImages = ['john-salzarulo.jpg', 'jeremy-thomas.jpg', 'ian-dooley.jpg', 'tim-marshall-57456.jpg'];
    //console.log('props.theme.themeName', props.theme.themeName);
    let themeImgOrName = props.theme.themeImg || '';
   // const themeName = props.theme.themeName || '';
    const unSplashSource: boolean = themeImgOrName && isUnsplashURL(themeImgOrName);
    if (unSplashSource) {
        defaultImages = defaultImages.concat(themeImgOrName);
    }
    console.log('props.theme.unSplashSource', unSplashSource);
    console.log('defaultImages', defaultImages);
    const [image, showImage] = React.useState<boolean>(false);
    const classNameValImg = 'displayCell wsBoardThemeImgDiv';
    const imgBaseUrl = imgUrl('/images/icons/board/');
    const [unsplashImages, setUnsplashImages] = React.useState<any[]>([]);
    const [searchImageText, searchImage] = React.useState<string>('');
    const imageScrollRef = React.createRef<HTMLDivElement>();

    const onScrollImage = (e: any) => {
      let element = e.target
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        // do something at end of scroll
        console.log('do scroll');
        const p: any = {};
        if (searchImageText) {
            p.query = searchImageText;
        }
        p.page = Math.ceil(unsplashImages.length / 30) + 1;
        loadImages(p);
      }
    }

    const [showTitle, showImageTitle] = React.useState<string>(null);
   
    const [refImageLoad] = useOnClickOutside(() => {
        hideUnsplashImgPopup();
    });

    const hideUnsplashImgPopup = () => {
        showImage(false);
        searchImage('');
        setUnsplashImages([]);
    }

    const getUnsplash = () => {
      showImage(true);
      loadImages({page: 1});
    }

    const onSearchImage = (e: any) => {
        e.preventDefault();
        const quer = e.target.value.trim();
        searchImage(quer);
        loadImages({ query: quer, page: 1 });
    }

    const selectImage = (e: any, img: any) => {
        unsplashDownload(img.links.download_location);
        hideUnsplashImgPopup();
        props.setTheme(e, "themeImg", img.urls.regular);
    }

    const unsplashDownload = (url: string) => {
        try {
            axios.get(`${wbConfig?.baseUrl ?? ''}/board/unsplashDownload`, {
                params: { url }
            });
        }
        catch(e) {
            console.log('Download unsplash image has been failed.', e);
        }
    }

    const loadImages = async(params: any = {}) => {
        try {
            const response = await axios.get(`${wbConfig?.baseUrl ?? ''}/board/unsplashPhotos`, {
                params: {...params},
            });
            const responseData = response.data || [];
            let imageData = responseData.results;
            if (params.page > 1) {
              imageData = uniqueArrayObject(imageData.concat(...imageData), 'id');
            }
            console.log('imageData', imageData);
            setUnsplashImages(imageData);
        }
        catch(e) {

        } 
    }
  
    return (
      <div className="wsBoardTopMenuContent_2">
        <div className="displayTable w100">
          <div className="displayRow">
            <div className="wsBoardChooseThemeText">
              {t('Choose an image as a background')}
            </div>
            {
              defaultImages.map((dImage: string, i: number) => 
                <ImageBox key={`dimage-${i}`}
                 image={dImage}
                 isActive={(themeImgOrName.indexOf(dImage) != -1)}
                 setTheme={props.setTheme}
                 />
              )
            }
            
            {!image  && (
              <div
                className={`wsBoardThemeImgWrap ${unSplashSource ? 'unSplasClickMore' : 'unSplasClick '}`}
                onClick={() => getUnsplash()}
              >
                {
                  unSplashSource ?
                  <div>{t('Search for more')}</div>
                  :
                  <div
                  className={classNameValImg}
                  style={{
                    backgroundImage: `url( ${imgBaseUrl}search4more.png)`
                  }}
                >
                  <div className="ImgAddIcon">
                    <img src={`${imgBaseUrl}blue_additem.png`} />
                  </div>
                  {t('Search for more images')}
                </div>
                }
              </div>
            )}
          </div>
          {image && (
            <div
              style={{position: 'relative'}}
            >
              <div id="unsplashImgLoad"
                style={{top: '-96px'}}
                className="unsplashImgLoad"
                ref={refImageLoad}>
                <div>
                    <div className="unsplashWrap">
                    <div className="unsplasTitle">
                        {t('Photos by')} <a href={`https://unsplash.com/?${UTM_STRING}`} target="_blank">Unsplash</a>
                    </div>
                    <div className="unsplasInputWrap">
                        <TextField
                          inputProps={{
                            placeholder: t("Search photos"),
                            style:{
                                width: '88%'
                            },
                            value: searchImageText
                          }}
                          onChangeText={onSearchImage}
                        />
                    </div>
                    <div className="imageWrap" ref={imageScrollRef} onScroll={(e) => onScrollImage(e)}>
                        {unsplashImages.map((uImage: any) => 
                            <ImageRow 
                                key={`irow-${uImage.id}`} 
                                uImage={uImage} 
                                selectImage={selectImage} 
                                onHover={showImageTitle}
                                showTitle={(showTitle == uImage.id)}
                            />
                        )}
                    </div>
                </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  
  }
  
  export default UnsplashImages;